import { defineMessages } from 'react-intl'

export default defineMessages({
  metricsTitle: {
    id: 'SpaceAnalyticsPage.Section.Publisher.MetricTitle',
    defaultMessage: 'Publisher Overview'
  },

  workshopMetricsTitle: {
    id: 'SpaceAnalyticsPage.Section.Publisher.WorkshopMetricsTitle',
    defaultMessage: 'Notification Overview'
  },

  workshopMetricsDescription: {
    id: 'SpaceAnalyticsPage.Section.Publisher.WorkshopMetricsDescription',
    defaultMessage:
      'Includes the total Notifications sent, unique views of those notifications, and engagement with them'
  },

  metricsDescription: {
    id: 'SpaceAnalyticsPage.Section.Publisher.MetricDescription',
    defaultMessage:
      'Includes the total Publisher notifications sent, unique views of those notifications, and interactions with them'
  },

  workshopChartTitle: {
    id: 'SpaceAnalyticsPage.Section.Publisher.WorkshopChartTitle',
    defaultMessage: 'Notification Engagement'
  },

  chartTitle: {
    id: 'SpaceAnalyticsPage.Section.Publisher.ChartTitle',
    defaultMessage: 'Publisher Interactions'
  },

  workshopChartDescription: {
    id: 'SpaceAnalyticsPage.Section.Publisher.WorkshopChartDescription',
    defaultMessage: 'Includes the unique times members interacted with Notifications, by detail panel, link, or button'
  },

  chartDescription: {
    id: 'SpaceAnalyticsPage.Section.Publisher.ChartDescription',
    defaultMessage: 'Includes the unique times members interacted with Publisher notifications'
  },

  totalSent: {
    id: 'SpaceAnalyticsPage.Section.Publisher.TotalSent',
    defaultMessage: 'TOTAL SENT'
  },

  uniqueViews: {
    id: 'SpaceAnalyticsPage.Section.Publisher.UniqueViews',
    defaultMessage: 'UNIQUE VIEWS'
  },

  engagement: {
    id: 'SpaceAnalyticsPage.Section.Publisher.Engagement',
    defaultMessage: 'INTERACTIONS'
  },

  clickedButtons: {
    id: 'SpaceAnalyticsPage.Section.Publisher.ClickedButtons',
    defaultMessage: 'Clicked Buttons'
  },

  openedDetail: {
    id: 'SpaceAnalyticsPage.Section.Publisher.OpenedDetail',
    defaultMessage: 'Opened Detail'
  },

  clickedLinks: {
    id: 'SpaceAnalyticsPage.Section.Publisher.ClickedLinks',
    defaultMessage: 'Clicked Links'
  }
})
